import axios from "axios";
import { url } from "components/common/api";
import { attachInterceptors } from "./interceptors";

const api = axios.create({
  baseURL: url,
  headers: {
    "Content-Type": "application/json",
  },
});

attachInterceptors(api);

export default api;

